import React, { useContext } from 'react';
import OverlayTrigger from 'react-bootstrap/esm/OverlayTrigger';
import cx from 'classnames';
import { useSelector } from 'src/client/redux';
import { Tooltip } from 'src/client/components/ui/Tooltip';
import { HeaderContext, HeaderPopovers } from './HeaderProvider';
import { ActivityFeed } from './ActivityFeed/ActivityFeed';
import { ImageButton, NavbarIcon } from './styles';
import { activity } from 'src/client/helpers/icons';
import { ensure } from 'src/client/utils/type-utils';
import { useActivityPopoverController } from './helpers/useActivityPopoverController';

type Props = {
  mainHeader: React.RefObject<HTMLDivElement>;
};

export const ActivityButton = (props: Props) => {
  const user = ensure(useSelector((state) => state.auth.user));
  const { activePopover } = useContext(HeaderContext);
  const { handleActivityFeedToggle, handleActivityFeedClick } = useActivityPopoverController();

  return (
    <OverlayTrigger
      container={props.mainHeader}
      placement="bottom"
      show={activePopover === HeaderPopovers.ACTIVITY}
      overlay={<ActivityFeed />}
      rootClose
      trigger={[]}
      onToggle={handleActivityFeedToggle}
    >
      <Tooltip value="Activity" placement="bottom">
        <ImageButton
          className={cx('hidden-xs', 'clickable', { 'hidden-md': !user.validSubscription })}
          onClick={handleActivityFeedClick}
        >
          <NavbarIcon icon={activity} />
        </ImageButton>
      </Tooltip>
    </OverlayTrigger>
  );
};
